// @ts-nocheck
import { Box, IconButton } from '@mui/material';
import { DotsSixVertical, Trash } from '@phosphor-icons/react';
import { Draggable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import { XGRadio } from 'xg-cl';
import * as PropTypes from 'prop-types';

const REQUIRED = 'required';
const OPTIONAL = 'optional';

const CollectionFieldRow = ({
  field,
  fieldUniqueId,
  draggableId,
  index,
  sectionType,
  isSubmitting = false,
  onAssignmentChange,
  onRemove,
  OnEditField
}) => {
  const { t } = useTranslation(['common']);
  const isDraggable = !field?.issystemfield;

  const renderActions = () => {
    // System field with assignment → readonly Required tag
    if (field?.issystemfield && field?.assignmenttype) {
      return (
        <Box className='passenger-collection-panel__field-actions passenger-collection-panel__field-actions--readonly'>
          <span className='passenger-collection-panel__field-tag passenger-collection-panel__field-tag--info'>
            {t('required')}
          </span>
          <Box className='passenger-collection-panel__field-remove-spacer' />
        </Box>
      );
    }

    // System fields with no assignment type have no actions
    if (field?.issystemfield) {
      return null;
    }

    // Non-system fields: assignment controls (for round sections) + remove button
    return (
      <Box className='passenger-collection-panel__field-actions'>
        {sectionType !== 'internal' && field?.assignmenttype && (
          <Box
            className='passenger-collection-panel__field-assignment-control'
            onClick={(event) => event.stopPropagation()}
          >
            <XGRadio
              id={`collection-field-required-${fieldUniqueId}`}
              name={`collection-field-assignment-${fieldUniqueId}`}
              label={t('required')}
              variant='pill'
              size='small'
              value={REQUIRED}
              checked={field?.assignmenttype === REQUIRED}
              disabled={isSubmitting}
              onChange={() => onAssignmentChange?.(REQUIRED)}
            />
            <XGRadio
              id={`collection-field-optional-${fieldUniqueId}`}
              name={`collection-field-assignment-${fieldUniqueId}`}
              label={t('optional')}
              variant='pill'
              size='small'
              value={OPTIONAL}
              checked={field?.assignmenttype === OPTIONAL}
              disabled={isSubmitting}
              onChange={() => onAssignmentChange?.(OPTIONAL)}
            />
          </Box>
        )}
        <IconButton
          className='passenger-collection-panel__field-remove'
          aria-label={t('delete')}
          title={t('delete')}
          disabled={isSubmitting}
          onClick={(event) => {
            event.stopPropagation();
            onRemove?.();
          }}
        >
          <Trash size={20} color='#1361D8' />
        </IconButton>
      </Box>
    );
  };

  return (
    <Draggable
      draggableId={draggableId}
      index={index}
      isDragDisabled={isSubmitting || !isDraggable}
    >
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={`passenger-collection-panel__field-row${isDraggable ? ' passenger-collection-panel__field-row--draggable' : ''}`}
          onClick={(event) => OnEditField(event, field)}
        >
          <Box className='passenger-collection-panel__field-copy'>
            {isDraggable ? (
              <Box
                className='passenger-collection-panel__field-leading-icon passenger-collection-panel__field-leading-icon--drag-handle'
                {...provided.dragHandleProps}
              >
                <DotsSixVertical size={16} />
              </Box>
            ) : (
              <Box className='passenger-collection-panel__field-leading-icon' />
            )}
            <span
              className={`passenger-collection-panel__field-title${field?.issystemfield ? ' passenger-collection-panel__field-title--system' : ''}`}
            >
              {field?.title}
            </span>
          </Box>
          {renderActions()}
        </div>
      )}
    </Draggable>
  );
};

CollectionFieldRow.propTypes = {
  field: PropTypes.shape({
    title: PropTypes.string,
    issystemfield: PropTypes.bool,
    assignmenttype: PropTypes.string
  }),
  fieldUniqueId: PropTypes.string.isRequired,
  draggableId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  sectionType: PropTypes.oneOf(['round', 'internal', 'at-booking']).isRequired,
  isSubmitting: PropTypes.bool,
  onAssignmentChange: PropTypes.func,
  onRemove: PropTypes.func,
  OnEditField: PropTypes.func
};

export default CollectionFieldRow;
